import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-web-tabs';
import { FaqData } from '../../../Utils/FaqData';
import icon from '../../../assets/images/Icon.svg';
import icon_selected from '../../../assets/images/Icon_selected.svg';

function Faq() {
  const [index, setIndex] = useState(0);
  const [value, setValue] = useState('');
  const [data, setData] = useState(FaqData['buy']);

  const setCurrentFaq = (i) => {
    setIndex(i);
  };

  const handleSearch = (e) => {
    console.log('valuee', e.target.value.toLocaleLowerCase());
    setValue(e.target.value);
    let result = FaqData['buy'].filter((item, i) =>
      (
        ((String(item.value.title).toLocaleLowerCase()
          ? String(item.value.title).toLocaleLowerCase()
          : String(item.value)
        ).toLocaleLowerCase() &&
          (String(item.value.content).toLocaleLowerCase()
            ? String(item.value.content).toLocaleLowerCase()
            : String(item.value)
          ).toLocaleLowerCase()) ||
        item.title.toLocaleLowerCase()
      ).includes(e.target.value.toLocaleLowerCase()),
    );
    setData(result !== undefined ? result : null);
  };

  return (
    <div className="faq_container mt">
      {console.log('dataaa', data)}
      <div className="faq_title">ReBid FAQs</div>
      <div className="faq_subtitle">
        If you don't see your question here, drop us a mail to:{' '}
        <a href="mailto:support@rebid.co">support@rebid.co</a>
      </div>
      <div className="faq_search">
        <input
          className="faq_search-input"
          type="text"
          value={value}
          onChange={handleSearch}
          placeholder="Search your query here"
        />
      </div>
      <div className="faq_tabs">
        <Tabs defaultTab="1">
          <TabList className="faq_tabs-header">
            <Tab tabFor="1">ReBid ADP</Tab>
            {/* <Tab tabFor="2">ReBid Desk</Tab> */}
            <Tab tabFor="3">ReBid CDP</Tab>
          </TabList>
          <TabPanel tabId="1">
            <div className="faq_data">
              <div className="faq_data-titles">
                {data.map((item, i) => (
                  <div
                    key={i}
                    className={i === index ? 'faq_data-title selected' : 'faq_data-title'}
                    onClick={() => setCurrentFaq(i)}
                  >
                    <div>
                      <img src={i === index ? icon_selected : icon} />
                      <span>{item.title}</span>
                    </div>
                    {i === index && <span className="faq_data-slider"></span>}
                  </div>
                ))}
              </div>
              <div className="faq_data-values">
                {data.length > 0 ? (
                  <div className="faq_data-value">
                    {!data[index].value.title && !data[index].value.content && (
                      <span className="faq_data-value_value">
                        {data && data[index].value && data[index].value}
                      </span>
                    )}
                    <span className="faq_data-value_title">
                      {data[index].value.title && data[index].value.title}
                    </span>
                    <span className="faq_data-value_content">
                      {data[index].value.content && data[index].value.content}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          </TabPanel>
          <TabPanel tabId="2">desk</TabPanel>
          <TabPanel tabId="3">insights</TabPanel>
        </Tabs>
      </div>
    </div>
  );
}

export default Faq;
